import { HttpBackend } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders, Provider, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { TranslationFeature, TranslationFeatureKind, LanguageService, LanguageLoaderBase, LanguageOptions, setTranslationConfig } from '@igo2/core/language';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { timeout, first, catchError } from 'rxjs';
import { NoCacheLanguageLoader } from './nocache-language.loader';


/* <Recopie de IGO 18.0.0 pour injecter le NoCacheLanguageLoader> */
export function provideTranslationSigt(
  featureConfig: TranslationFeature<TranslationFeatureKind.Translation>
): EnvironmentProviders {
  return makeEnvironmentProviders([
    ...featureConfig.providers,
    provideAppInitializer(() => {
        const initializerFn = ((languageService: LanguageService) => () => {
        const TIMEOUT_DURATION = 5000;
        return (
          languageService.translate.currentLoader as LanguageLoaderBase
        ).isLoaded$?.pipe(
          timeout(TIMEOUT_DURATION),
          first((isLoaded) => isLoaded === true),
          catchError((error) => {
            error.message += ` - Request timed out for language loader after: ${TIMEOUT_DURATION}`;
            throw error;
          })
        );
      })(inject(LanguageService));
        return initializerFn();
      })
  ]);
}

export function withStaticConfigSigt(
  options: LanguageOptions,
  defaultLanguage?: string | undefined): TranslationFeature<TranslationFeatureKind.Translation> {
  const loader: Provider = {
    provide: TranslateLoader,
    useFactory: (http: HttpBackend) => languageLoaderWithStaticSigt(http, options),
    deps: [HttpBackend]
  };
  return {
    kind: TranslationFeatureKind.Translation,
    providers: [
      importProvidersFrom(
        TranslateModule.forRoot(setTranslationConfig(loader, defaultLanguage))
      )
    ]
  };
}

function languageLoaderWithStaticSigt(
  http: HttpBackend,
  options?: LanguageOptions
) {
  return new NoCacheLanguageLoader(http, options); //<-- tout ça pour ça.
  //return new LanguageLoader(http, options);
}
/* </ Recopie de IGO 18.0.0 pour injecter le NoCacheLanguageLoader> */
